module.exports = __webpack_public_path__ + "static/media/stig.3133a4fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/working/assets/stig.png
// module id = 35
// module chunks = 0